import { useCalendarGrid, useLocale } from 'react-aria';
import { getWeeksInMonth, endOfMonth } from '@internationalized/date';
import { CalendarCell } from './CalendarCell';
import { CalendarState } from 'react-stately';

import styles from './CalendarGrid.module.scss';

interface CalendarGridProps {
  state: CalendarState;
}

export function CalendarGrid({ state }: CalendarGridProps) {
  const { locale } = useLocale();
  const startDate = state.visibleRange.start;
  const endDate = endOfMonth(startDate);
  const { gridProps, headerProps, weekDays } = useCalendarGrid(
    {
      startDate,
      endDate,
    },
    state
  );

  // Get the number of weeks in the month so we can render the proper number of rows.
  const weeksInMonth = getWeeksInMonth(state.visibleRange.start, locale);

  return (
    <table {...gridProps} className={styles.table}>
      <thead {...headerProps} className={styles.head}>
        <tr>
          {weekDays.map((day, index) => (
            <th key={index} className={styles.day}>
              {day}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {[...new Array(weeksInMonth).keys()].map((weekIndex) => (
          <tr key={weekIndex}>
            {state
              .getDatesInWeek(weekIndex, startDate)
              .map((date, i) =>
                date ? (
                  <CalendarCell
                    key={i}
                    state={state}
                    date={date}
                    currentMonth={startDate}
                    active={state.value?.day === date.day}
                  />
                ) : (
                  <td key={i} />
                )
              )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
